import fetchWithDefaults from './fetchWithDefaults';
import { MESSAGES } from '../CommonConstants';
import { ApiError } from '../errors/ApiError';

const extractFileNameFromContentDisposition = (contentDisposition: string | null) => {
  if (!contentDisposition) {
    return null;
  }

  // Matches three possible formats:
  // 1. filename=""example.pdf"" (double-pair quotes)
  // 2. filename="example.pdf" (single-pair quotes)
  // 3. filename=example.pdf (unquoted)
  const fileNameMatch = contentDisposition.match(
    /filename=""([^"]+)""|filename="([^"]+)"|filename=([^;,\s]+)/,
  );

  if (fileNameMatch) {
    // Return the first non-undefined captured group
    return fileNameMatch[1] || fileNameMatch[2] || fileNameMatch[3] || null;
  }

  return null;
};

export const authFetchBlob = async (
  input: RequestInfo,
  init?: RequestInit & { extendSession?: boolean; showSpinner?: boolean },
) => {
  try {
    // Until we migrate fetchWithDefaults, we will use it.
    const response = await fetchWithDefaults(input, init);

    if (response.ok) {
      const contentType = response.headers.get('Content-Type');

      if (contentType && contentType.includes('application/json')) {
        const { success, errors } = await response.json();

        if (!success) {
          throw new ApiError(errors[0]);
        }
      } else {
        const contentDispositionHeader = response.headers.get('content-disposition');

        const fileBlob = await response.blob();

        const fileName = extractFileNameFromContentDisposition(contentDispositionHeader);

        return { fileName, fileBlob };
      }
    }

    throw new Error();
  } catch (err) {
    if (err instanceof ApiError) {
      throw new Error(err.message);
    }
    throw new Error(MESSAGES.GENERIC_ERROR);
  }
};
